import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let MessageSendApi = class MessageSendApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getMessageList(params) {
        const url = this.urls.getMessageList;
        const res = this.http.get({
            url,
            params,
        });
        return res;
    }
};
MessageSendApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.MessageSendApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], MessageSendApi);
export { MessageSendApi };
